<template>
  <aside class="company-wall-details-cta">
    <div class="company-wall-details-cta--desktop">
      <SHeading class="company-wall-details-cta__title" level="3" size="4">
        {{ tr("main_site.company_wall.cta.title", { customerName }) }}
      </SHeading>

      <CompanyWallProductSelect
        v-if="geoProductCategories.length"
        class="company-wall-details-cta__product-select"
        :customer-id="customerId"
        :geo-product-categories="geoProductCategories"
      />

      <template v-if="usps.length">
        <strong class="company-wall-details-cta__usps__title">
          {{ tr("main_site.company_wall.cta.usps_title") }}
        </strong>
        <ul class="company-wall-details-cta__usps">
          <li
            v-for="(usp, index) in usps"
            :key="index"
            class="company-wall-details-cta__usps__item"
          >
            <i class="fas fa-check" /> <span v-html="usp" />
          </li>
        </ul>
      </template>
    </div>

    <div class="company-wall-details-cta--mobile">
      <SButton
        class="company-wall-details-cta__button"
        color="success"
        @click="modalVisible = true"
        >{{ tr("main_site.company_wall.cta.open_direct_match_form") }}
      </SButton>
      <PDialog v-model:visible="modalVisible" dismissable-mask modal>
        <template #header>
          <p class="company-wall-details-cta__title">
            {{ tr("main_site.company_wall.cta.title", { customerName }) }}
          </p>
        </template>

        <CompanyWallProductSelect
          v-if="geoProductCategories.length"
          class="company-wall-details-cta__product-select"
          :customer-id="customerId"
          :geo-product-categories="geoProductCategories"
        />

        <template v-if="usps.length">
          <strong class="company-wall-details-cta__usps__title">
            {{ tr("main_site.company_wall.cta.usps_title") }}
          </strong>
          <ul class="company-wall-details-cta__usps">
            <li
              v-for="(usp, index) in usps"
              :key="index"
              class="company-wall-details-cta__usps__item"
            >
              <i class="fas fa-check" /> <span v-html="usp" />
            </li>
          </ul>
        </template>
      </PDialog>
    </div>
  </aside>
</template>

<script setup lang="ts">
import { ref } from "vue";

import { SButton } from "@solvari/common-fe";
import { PDialog, SHeading } from "@solvari/components";
import { useI18nMainSiteCompanyWall } from "@solvari/translations";

import CompanyWallProductSelect from "~/features/company-wall/components/company-wall-details/cta/CompanyWallProductSelect.vue";
defineProps<{
  customerId: number;
  customerName: string;
  geoProductCategories: App.Data.CompanyWall.CompanyWallProductWithEndProductsData[];
  usps: string[];
}>();

const { tr } = useI18nMainSiteCompanyWall();

const modalVisible = ref(false);
</script>

<style lang="postcss">
.company-wall-details-cta {
  @apply sticky bottom-3 z-30 w-full;

  &--desktop {
    @apply hidden;

    .company-wall-details-cta__title {
      @apply mb-3;
    }
  }

  &__title {
    @apply mb-0 font-secondary text-xl font-bold text-primary-700;
  }

  &__button {
    @apply w-full;
  }

  &__usps {
    @apply space-y-2;

    &__title {
      @apply mb-2 mt-4 block font-semibold text-gray-700;
    }

    &__item {
      @apply text-gray-700;

      .fa-check {
        @apply mr-2 text-accent-500;
      }
    }
  }

  @screen 900 {
    @apply sticky top-20 shrink-0 space-y-4 self-start rounded border p-6;
    &--desktop {
      @apply block;
    }

    &--mobile {
      @apply hidden;
    }
  }

  @screen 1000 {
    @apply top-6;
  }
}
</style>
